import { createTypedSxStyles, capitalDesignTokens } from '@opengov/capital-mui-theme';
export const styles = createTypedSxStyles({
  progressTrackerSettingsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginTop: '16px',
    paddingRight: "24px"
  },
  progressTrackerSettingsHeaderContainer: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  progressTrackerSettingsButtonsContainer: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center'
  },
  progressTrackerSettingsContentContainer: {
    display: 'flex',
    gap: '24px',
    marginTop: '24px'
  },
  progressTrackerSettingsItemContainer: {
    display: 'flex',
    flex: '1',
    flexDirection: 'column'
  },
  progressTrackerSettingsItemHeaderContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '8px',
    gap: '24px'
  },
  previewContainer: {
    display: 'flex',
    flex: '1',
    padding: '16px',
    border: `1px solid ${capitalDesignTokens.semanticColors.border.secondary}`,
    borderRadius: '4px',
    backgroundColor: capitalDesignTokens.semanticColors.background.secondary,
    flexDirection: 'column',
    gap: '16px',
    '& .MuiRadioGroup-row': {
      gap: '40px',
      '& .MuiFormControlLabel-root': {
        marginRight: '0px',
        '& .MuiRadio-root': {
          '& .PrivateSwitchBase-input': {
            display: 'none'
          },
          '& .MuiSvgIcon-root': {
            fontSize: '14px',
          },
        }
      },
      '& .MuiFormControlLabel-label': {
        fontSize: '14px',
      }
    }
  },
  progressTrackerSettingItem: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '24px'
  },
  statusColorContainer: {
    display: 'flex',
    flex: 1,
    gap: '8px',
    '& .MuiOutlinedInput-root': {
      margin: 0,
      padding: 0,
      width: '100%',
      textTransform: 'capitalize',
      '& .MuiOutlinedInput-input, & .MuiInputBase-input': {
        padding: '0px 8px',
        height: '32px ',
        minHeight: '32px ',
        maxHeight: '32px',
        border: 'none'
      },
      '&.Mui-focused .MuiOutlinedInput-input, &.Mui-focused .MuiInputBase-input': {
        padding: '0px 8px',
        height: '32px',
        minHeight: '32px',
        maxHeight: '32px'
      }
    },
    '& .MuiInputBase-input': {
      padding: '0px 8px',
      height: '32px',
      minHeight: '32px',
      maxHeight: '32px',
      border: 'none',
      '& .MuiOutlinedInput-input, & .MuiInputBase-input': {
        padding: '0px 8px'
      },
      '&.Mui-focused .MuiOutlinedInput-input, &.Mui-focused .MuiInputBase-input': {
        padding: '0px 8px',
        height: '32px',
        minHeight: '32px',
        maxHeight: '32px',
        border: 'none'
      }
    }
  },
  labelPositioningContainer: {
    display: 'flex',
    flex: 1
  },
  colorBox: {
    padding: '4px 8px',
    borderRadius: '4px',
    border: `1px solid ${capitalDesignTokens.semanticColors.border.tertiary}`,
    backgroundColor: capitalDesignTokens.semanticColors.background.primary,
    height: '32px',
    width: '32px',
    '& .MuiSvgIcon-root': {
      height: '14px',
      width: '14px'
    }
  },
  labelPositioningToggleButtonGroupContainer: {
    display: 'flex',
    gap: '16px'
  },
  labelPositioningToggleButtonGroup: {
    '& .MuiToggleButton-root': {
      height: '32px',
      padding: '8px',
      '& .MuiSvgIcon-root': {
        height: '14px',
        width: '14px'
      }
    }
  },
  labelPositioningToggleButton: {
    height: '32px',
    padding: '8px',
    '& .MuiSvgIcon-root': {
      height: '14px',
      width: '14px'
    }
  },
  progressTrackerSettingsListContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  orientationSettingsContainer: {
    display: 'flex',
    flex: 2,
    gap: '8px',
    flexDirection: 'column'
  },
  addStatusButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-start'
  },
  progressTrackerSettingsHeaderTitle: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.h2,
    lineHeight: '32px',
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '8px',
    height: '32px',
    borderRadius: '4px',
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall,
    lineHeight: '16px',
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.bold,
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
    }
  },
  progressTrackerSettingsDescription: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyDefault,
    lineHeight: '20px',
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.normal,
    color: capitalDesignTokens.semanticColors.foreground.primary
  },
  rowHeader: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall,
    lineHeight: '16px',
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium,
    color: capitalDesignTokens.semanticColors.foreground.secondary,
    flex: 1
  },
  rowHeaderWithTooltip: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
      color: capitalDesignTokens.foundations.colors.gray800
    }
  },
  labelPreviewHeader: {
    flexGrow: 0
  },
  rowHeaderLabelPositioning: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall,
    lineHeight: '16px',
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium,
    color: capitalDesignTokens.semanticColors.foreground.secondary,
    flex: 1,
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '& .MuiSvgIcon-root': {
      fontSize: '16px',
      color: capitalDesignTokens.foundations.colors.gray800
    }
  },
  rowHeaderLabelPreview: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall,
    lineHeight: '16px',
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium,
    color: capitalDesignTokens.semanticColors.foreground.secondary,
    flex: 1,
    flexGrow: 0
  }
});
